module.exports = __webpack_public_path__ + "img/kakao.789c310f.svg";